export enum DashboardDrilldownBreadcrumbKey {
  DateRange = 'dateRange',
  ParentScope = 'parentScope',
  Entity = 'entity',
}
